import MoreVertIcon from '@mui/icons-material/MoreVert'
import IconButton from '@mui/material/IconButton'
import Menu from '@mui/material/Menu'
import Tooltip from '@mui/material/Tooltip'
import * as React from 'react'
import styles from './CardActionsMenu.pcss'

interface CardActionsMenuProps {
  className?: string
  buttonClassName?: string
  menuPaperClassName?: string
  tooltip?: React.ReactNode
  // EXPL: keep menu items mounted while closed so a Dialog nested in them survives menu close
  keepMounted?: boolean
  children: (close: () => void) => React.ReactNode
}

// EXPL: "..." overflow trigger + MUI menu shell shared by content/file cards
export function CardActionsMenu({ className, buttonClassName, menuPaperClassName, tooltip, keepMounted, children }: CardActionsMenuProps) {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null)
  const open = Boolean(anchorEl)

  const openMenu = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation()
    setAnchorEl(e.currentTarget)
  }

  const closeMenu = () => {
    setAnchorEl(null)
  }

  const stopPropagation = (e: React.MouseEvent) => {
    e.stopPropagation()
  }

  const button = (
    <IconButton
      aria-label="More"
      aria-haspopup="true"
      size="small"
      className={`${styles.button} ${buttonClassName || ''}`}
      onClick={openMenu}
      data-testid="btn-card-menu"
    >
      <MoreVertIcon />
    </IconButton>
  )

  return (
    <div className={`${styles.wrap} ${className || ''}`} onClick={stopPropagation}>
      {tooltip ? <Tooltip title={tooltip} placement="top">{button}</Tooltip> : button}
      <Menu
        anchorEl={anchorEl}
        open={open}
        keepMounted={keepMounted}
        classes={{ paper: `${styles.paper} ${menuPaperClassName || ''}`, root: styles.menuRoot }}
        onClose={closeMenu}
        onClick={stopPropagation}
      >
        {children(closeMenu)}
      </Menu>
    </div>
  )
}

export default CardActionsMenu
